<template>
    <div class="signInForm pb-5">
        <div class="pt-4 mx-3">
            <div class="d-flex justify-content-center align-items-center">
                <img border="0" :src="imgPath" width="120" height="120" alt="">
            </div>
        </div>
        <div class="signContainer" v-if="input_area">
            <h2 class="text-center py-3 bg-single comment-color">パスワード再設定</h2>
            <div class="invalid-regex-error" v-if="invalidmessage">
                <span class="text-danger">{{ invalid_access }}</span>
            </div>

            <form>
                <div class="mb-5">
                    <div class="form-group mb-3 row bg-single">
                        <label class="col-sm-3 col-form-label self comment-color">会員番号</label>
                        <div class="col-sm-9 self">
                            <p class="pschangeNo comment-color">{{ member_no }}</p>
                        </div>
                    </div>
                    <div class="form-group mb-3 row">
                        <label class="col-sm-3 col-form-label">
                            <span class="bg-single comment-color">新しいパスワード</span>
                            <span class="badge bg-danger text-white badge-required">※必須</span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                id="password"
                                type="password"
                                :class="{'is-invalid': valid.password}"
                                class="form-control"
                                v-model="password"
                                placeholder="半角英数字8文字以上"
                                @blur="checkInputData"
                                @input="checkInputData"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="valid.password"
                            >{{ valid_message.password }}</div>
                        </div>
                    </div>
                    <div class="form-group mb-3 row">
                        <label class="col-sm-3 col-form-label">
                            <span class="bg-single comment-color">新しいパスワード（確認）</span>
                            <span class="badge bg-danger text-white badge-required">※必須</span>
                        </label>
                        <div class="col-sm-9">
                            <input
                                id="rePassword"
                                type="password"
                                :class="{'is-invalid': valid.rePassword}"
                                class="form-control"
                                v-model="rePassword"
                                placeholder="半角英数字8文字以上"
                                @blur="checkInputData"
                                @input="checkInputData"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="valid.rePassword"
                            >{{ valid_message.rePassword }}</div>
                        </div>
                    </div>
                </div>
                <div class="mb-4">
                    <div class="row justify-content-center">
                        <button
                            type="button"
                            class="confirmbutton col-sm-4 mx-2 mt-2"
                            v-on:click="NextPage"
                            :disabled="submit_disabled"
                        >パスワードを登録する</button>
                        <button
                        type="button"
                        class="confirmbutton col-sm-4 mx-2 mt-2"
                        @click="toLoginPage()"
                        v-if="btnUse"
                        >
                        {{ btnName }}
                    </button>
                    </div>
                </div>
            </form>
        </div>
        <div class="signContainer" v-if="error_page">
            <h2 class="text-center py-3"></h2>
            <p class="mb-4 comment-color">{{ expiration }}</p>
        </div>
        <div class="signContainer" v-if="invalid_page">
            <h2 class="text-center py-3"></h2>
            <p class="mb-4 comment-color">{{ invalid_access }}</p>
        </div>
    </div>
</template>

<script>
import {
    CHANGE_FORGOT_PASSWORD,
    CHECK_TMP_MEMBER_PW
} from "../../constants/signin";
import validater from "../../lib/validater";
import { createApollo } from "../../lib/apollo";

export default {
    components: {
        validater
    },
    data () {
        return {
            member_no: null,
            input_area: true,
            error_page: false,
            invalid_page: false,
            password: "",
            rePassword: "",
            valid_flag: "",
            submit_disabled: true,
            email: "",
            token: "",
            error_text: "",
            expiration: "",
            invalid_access: "",
            invalidmessage: false,
            valid: {
                password: false,
                rePassword: false
            },
            valid_message: {
                password: "",
                rePassword: ""
            },
            btnUse: false,
            btnName: '',
            // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png"
        };
    },
    created () {
        this.initialize();
    },
    mounted () {},
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: async function() {
            this.$store.commit("loading/setIsLoading", true);
            this.member_no = "";
            this.password = "";
            this.rePassword = "";
            this.input_area = false;
            this.error_page = false;

            this.token = this.$route.query.token;

            try {
                let res = await this.$apollo.query({
                    query: CHECK_TMP_MEMBER_PW,
                    variables: {
                        token: this.token
                    }
                });
                this.member_no = res.data.getMemberNoTokenTmpPassword.member_no;
                this.valid_flag = res.data.getMemberNoTokenTmpPassword.valid_flag;

                if (this.valid_flag == 1) {
                    this.error_page = false;
                    this.input_area = true;
                } else {
                    this.expiration = this.$t("error.validation.expiration");
                    this.error_page = true;
                    this.input_area = false;
                }
            } catch (error) {

                if ( error.graphQLErrors[0].message == "Invalid Url") {
                        this.expiration = this.$t("error.validation.expiration");
                    } else {
                        this.expiration = this.$t("error.validation.systemError");
                    }
                this.error_page = true;
                this.input_area = false;
            }
            if (process.env.MIX_APP_URL) {
                this.btnUse = false;
                this.btnName = 'アプリを起動';
            } else {
                this.btnUse = true;
                this.btnName = 'ログインページに戻る';
            }
            this.$store.commit("loading/setIsLoading", false);
        },
        /** ----------------------------------------------
         * バリデーションチェック
         * ---------------------------------------------- */
        checkInputData: function(event) {
            if (event.type == "click") {
                if (!this.password) {
                    this.valid_message.password = this.$t(
                        "error.validation.required.password"
                    );
                    this.valid.password = true;
                }
                if (!this.rePassword) {
                    this.valid_message.rePassword = this.$t(
                        "error.validation.required.rePassword"
                    );
                    this.valid.rePassword = true;
                }
                // エラー状況をチェック
                if (!this.valid.password && !this.valid.rePassword) {
                    return true;
                }
                return false;
            } else if (event.type === 'blur') {
                if (!event.target.value) {
                    if (event.target.id === "password") {
                        this.valid_message.password = this.$t(
                            "error.validation.required.password"
                        );
                        this.valid.password = true;
                    } else if (event.target.id === "rePassword") {
                        this.valid_message.rePassword = this.$t(
                            "error.validation.required.rePassword"
                        );
                        this.valid.rePassword = true;
                    }
                } else {
                    if (event.target.id === "password") {
                        // パスワードチェック
                        if (
                            !validater.checkStringLengthMax(
                                event.target.value,
                                128
                            )
                        ) {
                            this.valid_message.password = this.$t(
                                "error.validation.length.passwordMax"
                            );
                            this.valid.password = true;
                        } else if (
                            !validater.checkStringLengthMin(
                                event.target.value,
                                8
                            )
                        ) {
                            this.valid_message.password = this.$t(
                                "error.validation.length.passwordMin"
                            );
                            this.valid.password = true;
                        } else if (!validater.checkStringType(this.password)) {
                            this.valid_message.password = this.$t(
                                "error.validation.stringtype"
                            );
                            this.valid.password = true;
                        } else if (!validater.checkComplexity(this.password)) {
                            this.valid_message.password = this.$t(
                                "error.validation.complexity"
                            );
                            this.valid.password = true;
                        } else {
                            // パスワード一致チェック
                            if (this.password && this.rePassword) {
                                if (this.password !== this.rePassword) {
                                    this.valid_message.password = this.$t(
                                        "error.validation.unmatchPassword"
                                    );
                                    this.valid.password = true;
                                } else {
                                    this.valid_message.password = "";
                                    this.valid.password = false;
                                    this.valid_message.rePassword = "";
                                    this.valid.rePassword = false;
                                }
                            } else {
                                this.valid_message.password = "";
                                this.valid.password = false;
                            }
                        }
                    } else if (event.target.id === "rePassword") {
                        // パスワード（確認）チェック
                        if (
                            !validater.checkStringLengthMax(
                                event.target.value,
                                128
                            )
                        ) {
                            this.valid_message.rePassword = this.$t(
                                "error.validation.length.rePasswordMax"
                            );
                            this.valid.rePassword = true;
                        } else if (
                            !validater.checkStringLengthMin(
                                event.target.value,
                                8
                            )
                        ) {
                            this.valid_message.rePassword = this.$t(
                                "error.validation.length.rePasswordMin"
                            );
                            this.valid.rePassword = true;
                        } else if (
                            !validater.checkStringType(this.rePassword)
                        ) {
                            this.valid_message.rePassword = this.$t(
                                "error.validation.stringtype"
                            );
                            this.valid.rePassword = true;
                        } else if (
                            !validater.checkComplexity(this.rePassword)
                        ) {
                            this.valid_message.rePassword = this.$t(
                                "error.validation.complexity"
                            );
                            this.valid.rePassword = true;
                        } else {
                            // パスワード一致チェック
                            if (this.password && this.rePassword) {
                                if (this.password !== this.rePassword) {
                                    this.valid_message.rePassword = this.$t(
                                        "error.validation.unmatchPassword"
                                    );
                                    this.valid.rePassword = true;
                                } else {
                                    this.valid_message.password = "";
                                    this.valid.password = false;
                                    this.valid_message.rePassword = "";
                                    this.valid.rePassword = false;
                                }
                            } else {
                                this.valid_message.rePassword = "";
                                this.valid.rePassword = false;
                            }
                        }
                    }
                }
                this.disabledCheck();
            } else {
                if (event.target.value) {
                    if (event.target.id === "password") {
                        // パスワードチェック
                        if (
                            !validater.checkStringLengthMax(
                                event.target.value,
                                128
                            )
                        ) {
                            this.valid_message.password = this.$t(
                                "error.validation.length.passwordMax"
                            );
                            this.valid.password = true;
                        } else if (
                            !validater.checkStringLengthMin(
                                event.target.value,
                                8
                            )
                        ) {
                            this.valid_message.password = this.$t(
                                "error.validation.length.passwordMin"
                            );
                            this.valid.password = true;
                        } else if (!validater.checkStringType(this.password)) {
                            this.valid_message.password = this.$t(
                                "error.validation.stringtype"
                            );
                            this.valid.password = true;
                        } else if (!validater.checkComplexity(this.password)) {
                            this.valid_message.password = this.$t(
                                "error.validation.complexity"
                            );
                            this.valid.password = true;
                        } else {
                            // パスワード一致チェック
                            if (this.password && this.rePassword) {
                                if (this.password !== this.rePassword) {
                                    this.valid_message.password = this.$t(
                                        "error.validation.unmatchPassword"
                                    );
                                    this.valid.password = true;
                                } else {
                                    this.valid_message.password = "";
                                    this.valid.password = false;
                                    this.valid_message.rePassword = "";
                                    this.valid.rePassword = false;
                                }
                            } else {
                                this.valid_message.password = "";
                                this.valid.password = false;
                            }
                        }
                    } else if (event.target.id === "rePassword") {
                        // パスワード（確認）チェック
                        if (
                            !validater.checkStringLengthMax(
                                event.target.value,
                                128
                            )
                        ) {
                            this.valid_message.rePassword = this.$t(
                                "error.validation.length.rePasswordMax"
                            );
                            this.valid.rePassword = true;
                        } else if (
                            !validater.checkStringLengthMin(
                                event.target.value,
                                8
                            )
                        ) {
                            this.valid_message.rePassword = this.$t(
                                "error.validation.length.rePasswordMin"
                            );
                            this.valid.rePassword = true;
                        } else if (
                            !validater.checkStringType(this.rePassword)
                        ) {
                            this.valid_message.rePassword = this.$t(
                                "error.validation.stringtype"
                            );
                            this.valid.rePassword = true;
                        } else if (
                            !validater.checkComplexity(this.rePassword)
                        ) {
                            this.valid_message.rePassword = this.$t(
                                "error.validation.complexity"
                            );
                            this.valid.rePassword = true;
                        } else {
                            // パスワード一致チェック
                            if (this.password && this.rePassword) {
                                if (this.password !== this.rePassword) {
                                    this.valid_message.rePassword = this.$t(
                                        "error.validation.unmatchPassword"
                                    );
                                    this.valid.rePassword = true;
                                } else {
                                    this.valid_message.password = "";
                                    this.valid.password = false;
                                    this.valid_message.rePassword = "";
                                    this.valid.rePassword = false;
                                }
                            } else {
                                this.valid_message.rePassword = "";
                                this.valid.rePassword = false;
                            }
                        }
                    }
                }
                this.disabledCheck();
            }
        },
        /** ----------------------------------------------
         * パスワードを登録するボタン制御処理
         * ---------------------------------------------- */
        disabledCheck: function() {
            if (
                this.password !== "" &&
                this.rePassword !== "" && // 必要フォームに値があり
                this.valid.password === false &&
                this.valid.rePassword === false // バリデーションに問題ない場合のみ
            ) {
                this.submit_disabled = false; // ボタン押下可能
            } else {
                this.submit_disabled = true;
            }
        },
        /** ----------------------------------------------
         * パスワードを登録するボタン処理
         * ---------------------------------------------- */
        NextPage: function(event) {
            if (this.checkInputData(event)) {
                const urlToken = this.$route.query.token;
                this.$store.commit("loading/setIsLoading", true);
                this.invalidmessage = false;

                this.$apollo
                    .mutate({
                        mutation: CHANGE_FORGOT_PASSWORD,
                        variables: {
                            url_token: urlToken,
                            password: this.password,
                            password_confirmation: this.rePassword
                        }
                    })
                    .then(res => {
                        this.$router.push({
                            path: "/passreset-setting-complete"
                        });
                    })
                    .catch(error => {
                        this.$store.commit("loading/setIsLoading", false);
                        this.invalid_access = error.graphQLErrors[0].message;
                        if (this.invalid_access == "The given data was invalid.") {
                            this.invalid_access = this.$t("error.validation.passwordRegexError");
                            this.invalidmessage = true;
                        } else {
                            if (error.graphQLErrors[0].message == "Invalid Url") {
                                this.invalid_access = this.$t("error.validation.expiration");
                            } else {
                                this.invalid_access = this.$t("error.validation.systemError");
                            }
                            this.error_page = false;
                            this.input_area = false;
                            this.invalid_page = true;
                        }
                    });
            }
        },
        toLoginPage: function() {
            if (process.env.MIX_APP_URL) {
                window.location.href = process.env.MIX_APP_URL;
            } else {
                this.$router.push("/");
            }
        }
    }
};
</script>

<style scoped>
    @media screen and (min-width: 576px) {
        .signContainer {
            width: 80%;
        }
    }
    .signInForm {
        height: 100vh;
    }
    @media screen and (max-width: 575px) {
        .signInForm {
            height: 100%;
        }
    }
</style>
